<ng-container
  *ngIf="connection?.syncPaused || connection?.airbnbListed === false || connection?.airbnbDeleted; else listingStatus"
>
  <span
    *ngIf="connection?.airbnbDeleted || connection?.syncPausedReason === 'deleted_on_airbnb'; else inactiveStatus"
    class="badge badge-danger badge-pill"
    matTooltip="This listing was deleted on Airbnb. AdvanceCM has paused Airbnb API sync for it."
    matTooltipPosition="above"
    i18n
    i18n-matTooltip
  >
    Deleted
  </span>
  <ng-template #inactiveStatus>
    <span
      *ngIf="connection?.syncPausedReason === 'unlisted_on_airbnb'; else genericInactiveStatus"
      class="badge badge-warning badge-pill"
      matTooltip="This listing is unlisted on Airbnb. AdvanceCM has paused Airbnb API sync for it."
      matTooltipPosition="above"
      i18n
      i18n-matTooltip
    >
      Unlisted
    </span>
    <ng-template #genericInactiveStatus>
      <span
        class="badge badge-warning badge-pill"
        matTooltip="This listing is no longer returned as active by Airbnb. AdvanceCM has paused Airbnb API sync for it."
        matTooltipPosition="above"
        i18n
        i18n-matTooltip
      >
        Inactive
      </span>
    </ng-template>
  </ng-template>
</ng-container>
<ng-template #listingStatus>
  <ng-container [ngSwitch]="statusCategory">
    <span *ngSwitchCase="'approved'" class="badge badge-success badge-pill" i18n>Approved</span>
    <span *ngSwitchCase="'rejected'" class="badge badge-danger badge-pill" i18n>Rejected</span>
    <span *ngSwitchCase="'in_progress'" class="badge badge-primary badge-pill" i18n>In Progress</span>
    <span
      *ngSwitchCase="'ready_for_review'"
      class="badge badge-info badge-pill"
      matTooltip="Airbnb has not yet reviewed this listing for API sync."
      matTooltipPosition="above"
      i18n
      i18n-matTooltip
      >Ready for Review</span
    >
    <span
      *ngSwitchCase="'new'"
      class="badge badge-secondary badge-pill"
      matTooltip="This listing has not been submitted to Airbnb for API sync review yet."
      matTooltipPosition="above"
      i18n
      i18n-matTooltip
      >New</span
    >
  </ng-container>
</ng-template>
